import { render, staticRenderFns } from "./instructions-questions.vue?vue&type=template&id=59dd18bb&scoped=true&"
import script from "./instructions-questions.vue?vue&type=script&lang=js&"
export * from "./instructions-questions.vue?vue&type=script&lang=js&"
import style0 from "./instructions-questions.vue?vue&type=style&index=0&id=59dd18bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dd18bb",
  null
  
)

export default component.exports